import Vue from "vue";
import Vuex from "vuex";
import {
  currentUserResource,
  currentGroupsResource,
  pageSettingsResource,
  authorizationResourceMembership,
  authorizationResourceExhibitor,
  paymentResource,
  exhibitorByTokenResource,
  exhibitorPersonResource,
  pageTypeResource,
  exhibitorVirtualExhibitionResource,
  exhibitorPayResource,
} from "./api/resources";
import { i18n } from "./plugins/i18n";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentUser: null,
    currentGroups: [],
    pageSettings: null,
    booths: [],
    currentExhibitor: null,
    pageType: null,
  },
  mutations: {
    setCurrentUser(state, payload) {
      state.currentUser = payload;
    },
    setCurrentGroups(state, payload) {
      state.currentGroups = payload;
    },
    setPageSettings(state, payload) {
      state.pageSettings = payload;
    },
    setBooths(state, payload) {
      state.booths = payload;
    },
    setCurrentExhibitor(state, payload) {
      state.currentExhibitor = payload;
    },
    setPageType(state, payload) {
      state.pageType = payload;
    },
  },
  actions: {
    async getCurrentUser({ commit }) {
      const currentUser = await currentUserResource
        .get("", {
          headers: {
            "x-xsrf-token": Vue.$cookies.get("oegg-cms.csrf"),
          },
        })
        .catch(() => (window.location = window.baseUrl + "/sso/login"));
      commit("setCurrentUser", currentUser.data);
    },
    async getCurrentGroups({ commit }) {
      const currentGroups = await currentGroupsResource.get("", {
        headers: {
          "x-xsrf-token": Vue.$cookies.get("oegg-cms.csrf"),
        },
      });
      commit("setCurrentGroups", currentGroups.data);
    },
    async getPageSettings({ commit }) {
      const settings = await pageSettingsResource.get(
        window.pageId || "clg3e19yz003zh3s832ztv8yg", //"cldt0ns7q001hkgujiddo4xqw",
        {
          headers: {
            "x-xsrf-token": Vue.$cookies.get("oegg-cms.csrf"),
          },
        }
      );
      commit("setPageSettings", settings.data);
    },
    async getPageType({ commit }) {
      const pageType = (await pageTypeResource.get()).data.type;
      commit("setPageType", pageType);
    },
    async getBooths({ commit }, token) {
      const booths = (await exhibitorByTokenResource.get(token)).data;
      commit("setBooths", booths);
      commit("setCurrentExhibitor", booths[0]);
    },
    updateCurrentExhibitor({ commit, state }, exhibitorId) {
      const exhibitor = state.booths.find((booth) => booth._id === exhibitorId);
      commit("setCurrentExhibitor", exhibitor);
    },
    async updateExhibitor({ commit, state }, persons) {
      await exhibitorPersonResource.post(
        "",
        {
          exhibitor: state.currentExhibitor,
          persons,
        },
        {
          headers: {
            "x-xsrf-token": Vue.$cookies.get("oegg-cms.csrf"),
          },
        }
      );
      commit("setCurrentExhibitor", { ...state.currentExhibitor, persons });
    },
    async updateExhibitorVirtualExhibitionData({ commit, state }, data) {
      const updatedExhibitor = (
        await exhibitorVirtualExhibitionResource.post(
          "",
          {
            id: state.booths[0]._id,
            additionalExhibitorId: state.booths[0].additionalExhibitorId,
            data,
          },
          {
            headers: {
              "x-xsrf-token": Vue.$cookies.get("oegg-cms.csrf"),
            },
          }
        )
      ).data;
      commit("setCurrentExhibitor", updatedExhibitor);
    },
    async updateExhibitorPay({ commit, state }, data) {
      const updatedExhibitor = (
        await exhibitorPayResource.post(
          "",
          {
            ids: [state.currentExhibitor._id],
            selectedPersons: data.selectedPersons,
            selectedBills: data.selectedBills,
          },
          {
            headers: {
              "x-xsrf-token": Vue.$cookies.get("oegg-cms.csrf"),
            },
          }
        )
      ).data;
      commit("setCurrentExhibitor", updatedExhibitor[0]);
    },
    async authorize({ state }, data) {
      try {
        const payment =
          state.pageType === "OEGG"
            ? (
                await authorizationResourceMembership.post(
                  "",
                  {},
                  {
                    headers: {
                      "x-xsrf-token": Vue.$cookies.get("oegg-cms.csrf"),
                    },
                  }
                )
              ).data
            : (
                await authorizationResourceExhibitor.post(
                  "",
                  { price: data.price },
                  {
                    headers: {
                      "x-xsrf-token": Vue.$cookies.get("oegg-cms.csrf"),
                    },
                  }
                )
              ).data;

        return payment;
      } catch (err) {
        return {
          err: true,
        };
      }
    },

    async charge({ state }, data) {
      return state.pageType === "OEGG"
        ? (
            await paymentResource.post(
              `/charge-membership/${data.sourceId}`,
              {},
              {
                headers: {
                  "x-xsrf-token": Vue.$cookies.get("oegg-cms.csrf"),
                },
              }
            )
          ).data
        : (
            await paymentResource.post(
              `/charge-exhibitor/${data.sourceId}`,
              { price: data.price },
              {
                headers: {
                  "x-xsrf-token": Vue.$cookies.get("oegg-cms.csrf"),
                },
              }
            )
          ).data;
    },
  },
  getters: {
    pageSettings: (state) => state.pageSettings,
    currentUser: (state) => state.currentUser,
    currentGroups: (state) => state.currentGroups,
    isAdministrator: (state) =>
      state.currentGroups.indexOf("administrator") >= 0,
    isMember: (state) => state.currentGroups.indexOf("member") >= 0,
    isReviewer: (state) => state.currentGroups.indexOf("reviewer") >= 0,
    dataTableFooterProps: () => ({
      "items-per-page-text": i18n.t("rowsPerPage"),
    }),
    booths: (state) => state.booths,
    currentExhibitor: (state) => state.currentExhibitor,
    pageType: (state) => state.pageType,
    editorDefaultToolbar: () => [
      "Bold",
      "Italic",
      "BulletedList",
      "Link",
      "Unlink",
      "Subscript",
      "Superscript",
    ],
  },
});
